import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "./api/axios";
import { useActivityLogger } from "./hooks/useActivity";
import { getImageUrl } from "./utils/image";
export default function OnlineCommunity() {
  const navigate = useNavigate();
  const [communities, setCommunities] = useState([]);
  const [loading, setLoading] = useState(true);
  const { logUserActivity, loading: userLoading } = useActivityLogger();

  useEffect(() => {
    const fetchCommunities = async () => {
      try {
        const res = await api.get("/komunitas");
        setCommunities(res.data);
        console.log("Fetched communities:", res.data);
      } catch (err) {
        console.error("Failed to fetch communities", err);
      } finally {
        setLoading(false);
      }
    };
    fetchCommunities();
    // Log user activity
    if (!userLoading) {
      logUserActivity(
        "user",
        "view_online_communities",
        "OnlineCommunity",
        "User viewed online communities"
      );
    }
  }, [userLoading]);

  if (communities.length === 0 && !loading) {
    return (
      <div className="min-h-screen bg-white px-4 py-4">
        <div className="text-center py-8 text-gray-500">
          Tidak ada komunitas yang tersedia.
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-white px-4 py-4">
      {/* Header */}
      <div className="flex items-center justify-between mb-6">
        <button
          onClick={() => {
            logUserActivity(
              "user",
              "go_back_from_online_community",
              "OnlineCommunity",
              "User navigated back from online communities"
            );
            navigate("/");
          }}
        >
          <img src="/icon-back.png" alt="Back" className="h-6 w-6" />
        </button>
        <h1 className="text-xl font-semibold">Komunitas Online</h1>
        <div className="h-6 w-6" /> {/* Spacer */}
      </div>

      <div>
        {loading ? (
          <div className="text-center py-8 text-gray-500">
            Memuat komunitas...
          </div>
        ) : (
          <div className="flex flex-col gap-4">
            {communities.map((community) => (
              <button
                key={community.ID}
                onClick={() => {
                  navigate("/online-community-details/" + community.ID);
                }}
                className="flex items-center gap-4 w-full bg-white border border-gray-200 rounded-lg shadow-sm px-4 py-3 hover:bg-blue-50 transition text-left"
              >
                <img
                  src={
                    community.image_url
                      ? // ? (process.env.REACT_APP_MEDIA_BASE || "") +
                        //   community.image_url
                        getImageUrl(community.image_url)
                      : "/avatar.png"
                  }
                  alt={community.nama_komunitas || "Komunitas"}
                  className="h-14 w-14 rounded-full object-cover border"
                />
                <span className="text-md text-gray-800 font-medium">
                  {community.nama_komunitas || (
                    <span className="italic text-gray-400">Tanpa Nama</span>
                  )}
                </span>
              </button>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
